import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost } from '../../../utils/axios';
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from './actions';

function* interpretSimple(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/interpret_simple/`, action.payload);
    const code = result.data?.response;
    if (code === 'READING_CONSUMED') {
      yield put(actions.interpretSimpleFailure({
        code,
        message: 'Ya realizaste tu interpretación de hoy. Vuelve mañana o solicita una lectura completa.',
      }));
      return;
    }
    if (code === 'NO_READINGS_AVAILABLE' || code === 'UNHANDLED_EXCEPTION') {
      yield put(actions.interpretSimpleFailure({
        code,
        message: 'No pudimos interpretar tu sueño en este momento. Intenta de nuevo.',
      }));
      return;
    }
    yield put(actions.interpretSimpleSuccess(result.data.reading));
  } catch (e) {
    yield put(actions.interpretSimpleFailure({
      code: 'UNKNOWN',
      message: 'Ocurrió un error inesperado. Intenta de nuevo.',
    }));
  }
}

function* setSimpleLike(action) {
  try {
    yield call(AxiosPost, `/suenos/set_simple_like/`, action.payload);
    yield put(actions.setSimpleLikeSuccess());
  } catch (e) {
    // silently fail, feedback is non-critical
  }
}

function* fetchPremium(action) {
  try {
    const { reading_id, email } = action.payload;
    const params = new URLSearchParams({ reading_id });
    if (email) params.append('email', email);
    const result = yield call(AxiosCall, `/suenos/get_premium_reading/?${params.toString()}`);
    if (result.data?.response === 'PENDING_REVIEW') {
      yield put(actions.premiumPending(result.data.eta_at));
    } else {
      yield put(actions.premiumSuccess(result.data));
    }
  } catch (e) {
    yield put(actions.premiumFailure(e));
  }
}

function* requestDeepReading(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/request_deep_reading/`, action.payload);
    const code = result.data?.response;
    if (code === 'PERK_REQUIRED') {
      yield put(actions.requestDeepReadingFailure({
        code, message: 'Necesitas el plan completo del Oráculo.',
      }));
      return;
    }
    if (code === 'READING_CONSUMED') {
      yield put(actions.requestDeepReadingFailure({
        code, message: 'Ya pediste tu lectura de hoy. Una por día.',
      }));
      return;
    }
    yield put(actions.requestDeepReadingSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.requestDeepReadingFailure({
      code: 'UNKNOWN', message: 'Ocurrió un error inesperado. Intenta de nuevo.',
    }));
  }
}

function* createPendingDeep(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/create_pending_deepreading/`, action.payload);
    yield put(actions.createPendingDeepSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.createPendingDeepFailure(e));
  }
}

function* suenosCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.suenosCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.suenosCheckoutFailure(e));
  }
}

function* suenosPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.suenosPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.suenosPaypalOrderFailure(e));
  }
}

function* suenosVerify(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/verify_purchase/`, action.payload);
    yield put(actions.suenosVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.suenosVerifyPurchaseFailure(e));
  }
}

function* suenosVerifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/suenos/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.suenosVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.suenosVerifyPaypalFailure(e));
  }
}

export default function* suenosSaga() {
  yield all([
    takeLatest(actions.INTERPRET_SIMPLE_REQUEST, interpretSimple),
    takeLatest(actions.SET_SIMPLE_LIKE_REQUEST, setSimpleLike),
    takeLatest(actions.PREMIUM_REQUEST, fetchPremium),
    takeLatest(actions.REQUEST_DEEP_READING_REQUEST, requestDeepReading),
    takeLatest(actions.CREATE_PENDING_DEEP_REQUEST, createPendingDeep),
    takeLatest(actions.SUENOS_CHECKOUT_REQUEST, suenosCheckout),
    takeLatest(actions.SUENOS_PAYPAL_REQUEST, suenosPaypalOrder),
    takeLatest(actions.SUENOS_VERIFY_REQUEST, suenosVerify),
    takeLatest(actions.SUENOS_VERIFY_PAYPAL_REQUEST, suenosVerifyPaypal),
  ]);
}
